<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins ds-MultiMenu">
			<!--Report Settings-->
			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Report Settings</h4>

				<div class="ds-MenuGrid">
					<!--Number of Days-->
					<label>Number of Days a report can exist before being purged by the System: </label>
					<!--Dropdown-->
					<select [disabled]="IsLoading() == true" class="form-control" name="NumDays" [(ngModel)]="ReportData.NumDays">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of NumDaysList" [ngValue]="o">
							{{ o }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateReportSettings()">Update</button>
			</div>

			<!--CAASS Mobile Settings (SU Only)-->
			<!-- <div *ngIf="user.userID == 0" class="ds-Menu ds-MultiMenuItem">
                <h4>CAASS Mobile Settings (SU Only)</h4>
                
                <div class="ds-MenuGrid">
                    <div class="ds-FlexText">
                        <label for="EnableOnRegServer">Enable on Registration Server:</label>
                        <input class="form-control" id="EnableOnRegServer" type="checkbox" [(ngModel)]="CAASSMobileSettingsData.EnableOnRegServer">
                    </div>
                    <div class="ds-FlexText">
                        <label for="EnableMobileAccess">Enable CAASS Mobile Access:</label>
                        <input class="form-control" id="EnableMobileAccess" type="checkbox" [(ngModel)]="CAASSMobileSettingsData.EnableMobileAccess">
                    </div>
                    
                    <label for="ServerName">User Friendly Server Name:</label>
                    <input class="form-control" id="ServerName" type="text" [(ngModel)]="CAASSMobileSettingsData.ServerName">

                    <label for="ServerURL">Server URL:</label>
                    <input class="form-control" id="ServerURL" type="text" [(ngModel)]="CAASSMobileSettingsData.ServerURL">

                </div>
                
                <button class="btn btn-primary" type="button" (click)="UpdateCAASSMobileSettings()">Update</button>
            </div> -->

			<!--Infraction Settings-->
			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Infraction Settings</h4>

				<div class="ds-MenuGrid">
					<!--Must add Action-->
					<label for="MustAddAction">Must add an Action from the primary Infraction: </label>
					<input
						[disabled]="IsLoading() == true"
						class="form-control ds-Rect"
						id="MustAddAction"
						type="checkbox"
						[(ngModel)]="InfractionData.MustAddAction"
					/>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateInfractionSettings()">Update</button>
			</div>

			<!-- <div class="ds-Menu ds-MultiMenuItem">
                <h4>CAASS Mobile Application Counts (SU Only)</h4>
                
                <div class="ds-MenuGrid">
                    <label>Mobile Appliction: </label>
                    <select class="form-control" name="MobileApp" [(ngModel)]="CAASSMobileAppCountsData.MobileApp">
                        <option value="" style="display:none;"></option>
                        <option *ngFor="let o of MobileAppList" [ngValue]="o.MobileApp">{{o.MobileApp}}</option>
                    </select>

                    <label>Accounts Currently Allocated:</label>
                    <label>{{CAASSMobileAppCountsData.CurrentCount}}</label>

                    <label>Maximum Accounts:</label>
                    <div class="ds-FlexText">
                        <input class="form-control" type="number" min="0" [(ngModel)]="CAASSMobileAppCountsData.MaximumCount">
                        <label class="ds-FlexMargin">For selected mobile application.</label>
                    </div>
                </div>
                
                <button class="btn btn-primary" type="button" (click)="UpdateCAASSMobileCounts()">Update</button>
            </div> -->

			<div *ngIf="user.userID == 0" class="ds-Menu ds-MultiMenuItem">
				<h4>Visitor Pass Plus Settings (SU Only)</h4>

				<div class="ds-MenuGrid">
					<label>Days Between Offender Searches:</label>
					<div class="ds-FlexText">
						<input [disabled]="IsLoading() == true" class="form-control" type="number" min="0" [(ngModel)]="VPPData.DaysBetweenSeaches" />
						<label class="ds-FlexMargin">(0 indicates search on each check-in)</label>
					</div>

					<label>Offender Hit Message:</label>
					<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="VPPData.OffenderHitMSG" />

					<label>Offender Hit Message Color:</label>
					<!--Color Picker-->
					<p-colorPicker [disabled]="IsLoading() == true" [inline]="false" [(ngModel)]="HitColorData"></p-colorPicker>

					<label>Automatic Denial on Offender Hit:</label>
					<input [disabled]="IsLoading() == true" class="form-control ds-Rect" type="checkbox" [(ngModel)]="VPPData.AutoDenialOnHit" />

					<label>Default Denial Duration Days:</label>
					<div class="ds-FlexText">
						<input [disabled]="IsLoading() == true" class="form-control" type="number" min="0" [(ngModel)]="VPPData.DefaultDenialDays" />
						<label class="ds-FlexMargin">(0 indicates indefinite duration)</label>
					</div>
				</div>

				<button class="btn btn-primary" type="button" (click)="UpdateVPPSettings()">Update</button>
			</div>

			<div *ngIf="user.userID == 0" class="ds-Menu ds-MultiMenuItem">
				<h4>District E-mail Domain (SU Only)</h4>

				<div class="ds-MenuGrid">
					<label>Domain Name: &#64;</label>
					<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="DistrictEmailData.DistrictDomain" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateDistrictEmailSettings()">Update</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Photo ID Settings</h4>

				<div class="ds-MenuGrid">
					<label>Default No Photo Found Image:</label>
					<select [disabled]="IsLoading() == true" class="form-control" name="DefaultNoPhoto" [(ngModel)]="PhotoIDSettingsData.DefaultNoPhoto">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of DefaultNoPhotoList" [ngValue]="o.ImageLibraryID">
							{{ o.ImageLibraryItemName }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdatePhotoIDSettings()">Update</button>
			</div>

			<div *ngIf="user.userID == 0" class="ds-Menu ds-MultiMenuItem">
				<h4>School E-mail Domains (SU Only)</h4>

				<div class="ds-MenuGrid">
					<label for="SchoolDomainAllowed">School Domains Allowed:</label>
					<input
						[disabled]="IsLoading() == true"
						id="SchoolDomainAllowed"
						class="form-control ds-Rect"
						type="checkbox"
						[(ngModel)]="SchoolEmailDomainsData.SchoolDomainAllowed"
					/>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateSchoolEmailDomains()">Update</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Default Page</h4>

				<div class="ds-MenuGrid">
					<label for="SchoolDomainAllowed">Page:</label>

					<select [disabled]="IsLoading() == true" class="form-control" name="SelectedDefaultPage" [(ngModel)]="DefaultPageData.SelectedDefaultPage">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of DefaultPageData.lstDefaultPages" [ngValue]="o">
							{{ o.Desc }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdateDefaultPage()">Update</button>
				<button [disabled]="IsLoading() == true" class="btn btn-danger" type="button" (click)="DistrictResetDefaultPage()">Reset</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Public Transit</h4>

				<div class="ds-MenuGrid">
					<label>Transit Label:</label>
					<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="PublicTransit.TransitLabel" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdatePublicTransit()">Update</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Nightly Attendance</h4>

				<div class="ds-MenuGrid">
					<label for="MarkIsCountPresentAsPresent">Mark valid releases as present:</label>

					<input
						[disabled]="IsLoading() == true"
						id="MarkIsCountPresentAsPresent"
						class="form-control ds-Rect"
						type="checkbox"
						[(ngModel)]="NightlyAttendanceData.MarkIsCountPresentAsPresent"
					/>
				</div>

				<div>
					<p class="ds-InstructionText">
						<span style="font-weight: bold">NOTE:</span> Daily attendance is updated each night and students are marked as absent if they never
						scanned into school. This preference sets how to mark students who have a full-day release with an excuse that counts as present.
						Normally they are just marked as absent but it is recorded that they had a release that day (This makes sense when students must
						physically be in school for x days per year.) Turning this preference on means the students will be marked as present for the day even
						though they didn't enter the building (Doing schoolwork from home would be counted as present).
					</p>
				</div>

				<div class="ds-ULInfo">
					<label class="ds-ULSubHeading">Daily Attendance if turned OFF:</label>
					<ul class="ds-UL">
						<li>Status = Absent</li>
						<li>Entry Type = System Marked Absent</li>
						<li>Excuse = Has Release</li>
					</ul>

					<label class="ds-ULSubHeading">Daily Attendance if turned ON:</label>
					<ul class="ds-UL">
						<li>Status = Present (Even though they never entered the school. Ex. Doing schoolwork from home)</li>
						<li>Entry Type = Assumed Present</li>
						<li>Excuse = Release's Excuse</li>
					</ul>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdateNightlyAttendance()">Update</button>
			</div>

			<!-- <div *ngIf="HasParentPortalEnabled == true" class="ds-Menu ds-MultiMenuItem">
				<h4>Portal Apps:</h4>

				<div class="Divider"></div>

				<h4>Parent Portal:</h4>

				<div class="ds-MenuGrid">
					<label>Send Absent Notification at: </label>
					<p-calendar
						[disabled]="IsLoading() == true"
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="ScheduleTime"
						name="ScheduleTime"
						appendTo="body"
						timeOnly="true"
						showTime="true"
						hourFormat="12"
					></p-calendar>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdatePortalApps()">Update</button>
			</div> -->
		</div>

		<!--Error Message-->
		<div class="TopMargin">
			<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
		</div>
	</div>
</div>
